/**
 * External dependencies
 */
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Card from "components/card";

/**
 * Style dependencies
 */
import "./styles.scss";

const Section = (props) => {
  return (
    <Card
      className={classNames(props.className, "section-card", {
        "is-compact": props.compact,
        padded: props.padded,
      })}
    >
      {props.label && (
        <div className="section-card__header">
          <div className="section-card__header-label">
            <Text size="small" weight="medium">
              {props.label}
            </Text>
          </div>
          <div className="section-card__header-actions">{props.actions}</div>
        </div>
      )}
      <div className="section-card__content">{props.children}</div>
    </Card>
  );
};

Section.propTypes = {
  label: PropTypes.string.isRequired,
};

Section.defaultProps = {
  padded: true,
};

export default Section;
